import { twMerge } from "tailwind-merge";

export function SmallTitle({
  children,
  elementType,
  className,
}: {
  children: React.ReactNode;
  elementType: "p" | "span";
  className?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge(
        "text-sm font-medium leading-6 text-gray-900",
        className
      )}
    >
      {children}
    </Element>
  );
}
